import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-button-primary',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button-primary.component.html',
  styles: ``
})
export class ButtonPrimaryComponent {
  public label = input<string>('');
  public type = input<'default' | 'negative'>('default');
  public disabled = input<boolean>(false);
  public buttonClicked = output<boolean>();
}
